import React from 'react'
import {useTranslation} from 'i18n'
import {useSelector} from 'lib/redux'
import GiftShopTemplateOptionsItem from './GiftShopTemplateOptionsItem'
import {GiftShopTemplateOptionsModalProps} from './GiftShopTemplateOptionsProps'
import GiftShopTemplateOptionsContent from './GiftShopTemplateOptionsContent'

export default function GiftShopFeedOptionsModal({
  isProfilePost,
  onBlock,
  onDelete,
  onEdit,
  onRemoveCollab,
  onReport,
  onShare,
  onRotate,
  toggleModal,
}: GiftShopTemplateOptionsModalProps) {
  const {translate} = useTranslation()
  const {isAdmin} = useSelector('forkygramHomefeedsState') || {}

  return (
    <GiftShopTemplateOptionsContent visible toggleModal={toggleModal}>
      <div>
        {onShare && (
          <GiftShopTemplateOptionsItem
            icon="share"
            text={translate('global:shareContent')}
            onClickItem={onShare}
          />
        )}
        {onReport && (
          <GiftShopTemplateOptionsItem
            icon="report"
            text={translate('global:reportContent')}
            onClickItem={onReport}
          />
        )}
        {onEdit && (
          <GiftShopTemplateOptionsItem
            icon="pencil"
            text={translate('global:editContent')}
            onClickItem={onEdit}
          />
        )}
        {onDelete && (
          <GiftShopTemplateOptionsItem
            icon="trash"
            text={translate(
              isProfilePost ? 'forkygram:postDelete' : 'global:deleteContent',
            )}
            onClickItem={onDelete}
          />
        )}
        {onRemoveCollab && (
          <GiftShopTemplateOptionsItem
            icon="circular-cross"
            color="danger_5"
            text={translate('tree:removeCollaboration')}
            onClickItem={onRemoveCollab}
          />
        )}
        {onBlock && (
          <GiftShopTemplateOptionsItem
            icon="block"
            text={translate('forkygram:blockYuserAcc')}
            onClickItem={onBlock}
          />
        )}
        {isAdmin && onRotate && (
          <GiftShopTemplateOptionsItem
            icon="rotate"
            text={translate('global:rotate')}
            onClickItem={onRotate}
          />
        )}
      </div>
    </GiftShopTemplateOptionsContent>
  )
}
